import { Skeleton } from "antd";
import React from "react";

export const InfoCard = ({ title, count, icon, onClick, loading }) => {
  return (
    <div
      className="bg-white shadow-md rounded-lg p-4 flex items-start space-x-4 hover:shadow-lg transition cursor-pointer overflow-visible"
      onClick={onClick}
    >
      {/* {loading ? (
        <div className="flex-shrink-0">
          <Skeleton.Avatar active size="small" />
        </div>
      ) : (
        <div className="text-blue-900 text-3xl flex-shrink-0 mt-2">{icon}</div>
      )} */}
      <div className="flex-grow overflow-hidden">
        <h3 className="text-gray-600 font-semibold break-words whitespace-normal">
          {title}
        </h3>
        {loading ? (
          <div className="w-full overflow-hidden">
            <Skeleton.Input
              active
              size="small"
              style={{ width: "100%", maxWidth: "100%" }}
            />
          </div>
        ) : (
          <p className="text-xl font-bold break-words whitespace-normal">
            {count}
          </p>
        )}
      </div>
    </div>
  );
};
